import styled from '@emotion/styled';

const Container = styled('div')({
  margin: '8rem auto 5rem',
  maxWidth: '107rem',
});

export default Container;
